// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"886":"c45196d328fbffac","2888":"33c9fb06cb902247"}[chunkId] + ".css";
};